import reduce from 'lodash/reduce'

export const serializeQueryParams = (params = {}) => reduce(
  Object.entries(params),
  (acc, [param, value], index) =>
    `${ acc + (index === 0 ? '?' : '&') + param  }=${ value }`,
  ''
)
